<template>
    <v-dialog persistent max-width="500px" v-model="show">
        <v-card v-if="task && assembly">
            <v-card-title class="headline">Delegate</v-card-title>
            <v-card-text v-if="state == 'confirm'">
                <p>
                    You are about to delegate <b>{{ task.action | kebabToTitle }}</b> to your team.
                    Once your team member completes the task, their progress will help to complete {{ assembly.name }}.
                    <b>This will cost you 1 action point.</b>
                </p>
            </v-card-text>
            <v-card-text v-if="state == 'wait'">
                <div class="text-center mt-10">
                    <v-progress-circular indeterminate color="primary" :size="50" class="mb-6"></v-progress-circular>
                    <p>The task is being delegated. Please wait...</p>
                </div>
            </v-card-text>
            <v-card-text v-if="state == 'selectRole'">
                <p>
                    There are multiple roles that can peform <b>{{ task.action | kebabToTitle }}</b>.
                    Which role would you like to delegate this task to?
                </p>
                <v-select :items="eligibleRoles" label="Role" item-text="name" item-value="id" v-model="selectedRole"/>
            </v-card-text>

            <v-card-actions v-if="state == 'confirm' || state == 'selectRole'">
                <v-spacer></v-spacer>
                <v-btn color="secondary" text @click.stop="close()">Cancel</v-btn>
                <v-btn color="primary" text @click.stop="continueButton()" :disabled="state == 'selectRole' && !selectedRole">Continue</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { kebabToTitle } from '../util';

export default {
    props: {
        value: Boolean,
        task: Object,
        assembly: Object
    },
    filters: {
        kebabToTitle
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit("input", value);
            }
        }
    },
    data: () => ({
        state: "confirm",
        eligibleRoles: [],
        selectedRole: null
    }),
    sockets: {
        delegate_res(res) {
            this.$log.debug("Got delegate response", res);

            this.state = res.step || "wait";
            this.eligibleRoles = res.eligibleRoles || [];

            if (this.state == 'done') {
                this.close();
            }
        }
    },
    methods: {
        close() {
            this.show = false;
            this.state = 'confirm';
            this.selectedRole = null;
            this.eligibleRoles = [];
        },
        continueButton() {
            if (this.state == 'confirm') {
                this.$socket.client.emit("delegate", {
                    type: "task",
                    task: this.task.action,
                    assembly: this.assembly.id
                });
                this.state = 'wait';
            } else if (this.state == 'selectRole') {
                this.$socket.client.emit("delegate", {
                    type: "task",
                    task: this.task.action,
                    assembly: this.assembly.id,
                    role: this.selectedRole
                });
                this.state = 'wait';
            }
        }
    }
}
</script>
